import React from "react";
import { Box } from "../components/Flex";
import getDisplayName from "../lib/utils";

type WithSpacingProps = {
  defaultSpacing?: boolean;
};

export default function withSpacing(Page) {
  class WithSpacing extends React.Component<
    WithSpacingProps,
    WithSpacingProps
  > {
    constructor(props: WithSpacingProps) {
      super(props);
      this.state = {
        defaultSpacing:
          typeof props.defaultSpacing === "boolean"
            ? props.defaultSpacing
            : true,
      };
    }

    render() {
      const desktopSeparation = 70;
      return (
        <>
          {/* <Media greaterThanOrEqual="md"> */}
          <Box height={desktopSeparation} />
          <Page {...this.props} />
          <Box height={desktopSeparation} />
          {/* </Media> */}

          {/* <Media lessThan="md">
            <Box height={mobileSeparation} />
            <Page {...this.props} />
            <Box height={mobileSeparation} />
          </Media> */}
        </>
      );
    }
  }

  // @ts-ignore
  WithSpacing.displayName = `WithSpacing(${getDisplayName(Page)})`;
  return WithSpacing;
}
